export default {
	messages: {
		required: (field) => `Este campo es requerido`,
		length: (field) => `El campo está mal formado`,
	},
	custom : {
		email : {
			required : 'El campo email es obligatorio',
			email : 'Debes indicar una dirección de correo electrónico válida'
		},
		telefono : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado',
			min : "El campo teléfono está mal formado",
			integer  :"El campo teléfono está mal formado"
		},
		nombre : {
			required : 'El campo nombre es obligatorio'
		},
		mensaje : {
			required : 'El campo mensaje es obligatorio'
		},
		apellidos : {
			required : 'El campo apellidos es obligatorio'
		},
		politica : {
			required : 'Debes aceptar la política de privacidad'
		},
		birthday : {
			required : 'Este campo es obligatorio'
		},
		direccion : {
			required : 'El campo direccion es obligatorio'
		},
		pais : {
			required : 'El campo pais es obligatorio'
		},
		carta_presentacion : {
			required : 'El campo carta de presentación es obligatorio'
		},
		doc_adjunto : {
			size : 'El tamaño maximo son 2MB',
			mimes : 'El formato debe ser PDF'
		},
		file : {
			size : 'El tamaño maximo son 10MB',
			mimes : 'El formato debe ser PDF'
		},
		productfile : {
			size : 'El tamaño maximo son 2MB',
			mimes : 'El formato debe ser imagen o PDF'
		},
		cp : {
			length : 'El campo código postal está mal formado'
		}
	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js